/* mf-product-card-gallery.js
   Rotacion automatica de imagenes en la card SOLO en touch (mobile).
   Desktop usa hover puro via CSS (no toca este script).
   - Avanza entre capas .product-image cada CYCLE_MS.
   - Solo cicla mientras la card esta visible (IntersectionObserver) para no gastar timers.
   - Respeta prefers-reduced-motion. */
(function () {
  "use strict";

  var CYCLE_MS = 1800;
  var mqTouch = window.matchMedia("(hover: none)");
  var mqReduce = window.matchMedia("(prefers-reduced-motion: reduce)");

  function layers(gallery) {
    return Array.prototype.slice.call(gallery.querySelectorAll(".product-image"));
  }

  function startCycle(gallery) {
    if (gallery._mfTimer) return;
    var imgs = layers(gallery);
    if (imgs.length < 2) return;

    gallery.classList.add("mf-cycling");
    gallery._mfIdx = 0;
    imgs.forEach(function (im, i) {
      im.classList.toggle("is-active", i === 0);
    });

    gallery._mfTimer = window.setInterval(function () {
      imgs[gallery._mfIdx].classList.remove("is-active");
      gallery._mfIdx = (gallery._mfIdx + 1) % imgs.length;
      imgs[gallery._mfIdx].classList.add("is-active");
    }, CYCLE_MS);
  }

  function stopCycle(gallery) {
    if (gallery._mfTimer) {
      window.clearInterval(gallery._mfTimer);
      gallery._mfTimer = null;
    }
    gallery.classList.remove("mf-cycling");
    layers(gallery).forEach(function (im) {
      im.classList.remove("is-active");
    });
  }

  function init() {
    // Desktop o motion reducido: no auto-rotacion (hover CSS se encarga en desktop)
    if (!mqTouch.matches || mqReduce.matches) return;

    var galleries = document.querySelectorAll("[data-mf-gallery]");
    if (!galleries.length) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) startCycle(entry.target);
          else stopCycle(entry.target);
        });
      },
      { threshold: 0.5 }
    );

    galleries.forEach(function (gallery) {
      if (gallery.hasAttribute("data-mf-gallery-init")) return;
      if (layers(gallery).length < 2) return;
      gallery.setAttribute("data-mf-gallery-init", "");
      io.observe(gallery);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", function () {
    window.setTimeout(init, 50);
  });
})();
